import React from 'react';

import { Container } from './styles';

const ContainerFilter: React.FC = ({ children }) => {
    return <Container>{children}</Container>;
};

export default ContainerFilter;
